export const CITY_REDIRECTS: Record<string, string> = {
  // === ZONAS /zonas/ → hubs régionaux (routes sans page React dédiée) ===

  // → Axarquía
  '/zonas/comares': '/zonas/axarquia',
  '/zonas/macharaviaya': '/zonas/axarquia',
  '/zonas/frigiliana': '/zonas/axarquia',
  '/zonas/competa': '/zonas/axarquia',
  '/zonas/canillas-de-aceituno': '/zonas/axarquia',
  '/zonas/canillas-de-albaida': '/zonas/axarquia',
  '/zonas/sayalonga': '/zonas/axarquia',
  '/zonas/archez': '/zonas/axarquia',
  '/zonas/sedella': '/zonas/axarquia',
  '/zonas/salares': '/zonas/axarquia',
  '/zonas/riogordo': '/zonas/axarquia',
  '/zonas/periana': '/zonas/axarquia',

  // → Valle del Guadalhorce
  '/zonas/almogia': '/zonas/valle-del-guadalhorce',
  '/zonas/pizarra': '/zonas/valle-del-guadalhorce',
  '/zonas/casarabonela': '/zonas/valle-del-guadalhorce',
  '/zonas/carratraca': '/zonas/valle-del-guadalhorce',
  '/zonas/ardales': '/zonas/valle-del-guadalhorce',
  '/zonas/valle-de-abdalajis': '/zonas/valle-del-guadalhorce',

  // → Serranía de Ronda
  '/zonas/juzcar': '/zonas/serrania-de-ronda',
  '/zonas/pujerra': '/zonas/serrania-de-ronda',
  '/zonas/igualeja': '/zonas/serrania-de-ronda',
  '/zonas/cartajima': '/zonas/serrania-de-ronda',
  '/zonas/farajan': '/zonas/serrania-de-ronda',
  '/zonas/alpandeire': '/zonas/serrania-de-ronda',
  '/zonas/gaucin': '/zonas/serrania-de-ronda',
  '/zonas/casares': '/zonas/serrania-de-ronda',
  '/zonas/genalguacil': '/zonas/serrania-de-ronda',
  '/zonas/benalauria': '/zonas/serrania-de-ronda',
  '/zonas/benarraba': '/zonas/serrania-de-ronda',

  // === PERSIANAS /persianas/ → hubs régionaux (doorway pages villages) ===

  // → Axarquía
  '/persianas/algarrobo': '/zonas/axarquia',
  '/persianas/competa': '/zonas/axarquia',
  '/persianas/frigiliana': '/zonas/axarquia',
  '/persianas/sayalonga': '/zonas/axarquia',
  '/persianas/torrox': '/zonas/axarquia',

  // → Valle del Guadalhorce
  '/persianas/almogia': '/zonas/valle-del-guadalhorce',
  '/persianas/pizarra': '/zonas/valle-del-guadalhorce',
  '/persianas/alora': '/zonas/valle-del-guadalhorce',
  '/persianas/cartama': '/zonas/valle-del-guadalhorce',
  '/persianas/coin': '/zonas/valle-del-guadalhorce',
  '/persianas/alhaurin-de-la-torre': '/zonas/valle-del-guadalhorce',
  '/persianas/alhaurin-el-grande': '/zonas/valle-del-guadalhorce',

  // → Serranía de Ronda
  '/persianas/casares': '/zonas/serrania-de-ronda',
  '/persianas/ronda': '/zonas/serrania-de-ronda',
  '/persianas/istan': '/zonas/serrania-de-ronda',
  '/persianas/ojen': '/zonas/serrania-de-ronda',
  '/persianas/benahavis': '/zonas/serrania-de-ronda',
  '/persianas/archidona': '/zonas/serrania-de-ronda',
  '/persianas/manilva': '/zonas/serrania-de-ronda',
  '/persianas/san-pedro-de-alcantara': '/zonas/serrania-de-ronda',
};